const errors = {
    'bad.phone_number': 'You entered the wrong mobile phone number'
};

export default errors;